import { useLanguage } from "@/contexts/LanguageContext";
import { images } from "@/i18n/content";
import { ArrowUpRight } from "lucide-react";

const Hero = () => {
  const { t, isRTL } = useLanguage();

  const imageSideClass = isRTL
    ? "left-0 right-auto"
    : "right-0 left-auto";

  const maskImage = isRTL
    ? "linear-gradient(to right, black 0%, black 45%, rgba(0,0,0,0.35) 75%, transparent 100%), linear-gradient(to top, transparent 0%, black 35%)"
    : "linear-gradient(to left, black 0%, black 45%, rgba(0,0,0,0.35) 75%, transparent 100%), linear-gradient(to top, transparent 0%, black 35%)";

  const imageStyle = {
    WebkitMaskImage: maskImage,
    maskImage: maskImage,
    WebkitMaskComposite: "source-in",
    maskComposite: "intersect",
    WebkitMaskSize: "100% 100%",
    maskSize: "100% 100%",
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden grain bg-ink"
    >
      <div
        className={`pointer-events-none absolute top-0 bottom-0 ${imageSideClass} w-full sm:w-[62%] lg:w-[52%] xl:w-[48%]`}
        aria-hidden="true"
      >
        <img
          src={images.hero}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-[72%_top] sm:object-top opacity-90"
          loading="eager"
          style={imageStyle}
        />
      </div>

      <div className="absolute inset-0 bg-ink/50 sm:bg-ink/10 pointer-events-none" />

      <div className="relative z-10 container-x min-h-[100svh] flex flex-col justify-end pb-10 sm:pb-24 pt-40 lg:pt-28">
        <div className="max-w-2xl animate-fade-up max-sm:translate-y-32">
          <div className="flex items-center gap-4 mb-5 sm:mb-8">
            <span className="hairline" />
            <span className="overline" data-testid="hero-overline">
              {t.hero.overline}
            </span>
          </div>

          <h1
            className={`${
              isRTL
                ? "font-arabic font-black leading-[1.05]"
                : "font-serif font-normal leading-[0.95]"
            } text-bone text-[2rem] sm:text-6xl lg:text-8xl xl:text-[7rem] tracking-tight`}
            data-testid="hero-name"
          >
            عبدالعزيز البكر
          </h1>

          <p
            className={`mt-5 sm:mt-8 text-white/80 max-w-xl text-base sm:text-xl leading-relaxed ${
              isRTL ? "font-arabic" : ""
            }`}
            data-testid="hero-title"
          >
            {t.hero.title}
          </p>

          <p
            className={`mt-4 sm:mt-6 text-white/65 max-w-xl text-sm sm:text-base leading-relaxed ${
              isRTL ? "font-arabic" : ""
            }`}
            data-testid="hero-lede"
          >
            {t.hero.lede}
          </p>

          <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a href="#contact" className="btn-gold group" data-testid="hero-cta-primary">
              <span>{t.hero.ctaPrimary}</span>
              <ArrowUpRight
                size={16}
                className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>

            <a href="#timeline" className="btn-ghost" data-testid="hero-cta-secondary">
              {t.hero.ctaSecondary}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
